import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MUITooltip from "@mui/material/Tooltip";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { ForestChip } from "./HXDesktopChips.styles";
import { TinyTextLighter as DefaultTinyTextLighter, LightText } from "./HXMobilePage.styles";
const radioIconSize = 42;
const profilePageBackground = "#FFFEFC";
export const ProfilePopoverHeaderContainer = styled(FlexRowDiv) `
    display: flex;
    align-self: stretch;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    padding: 24px 16px 12px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.black_12};
`;
export const ProfileHeroAvatarNameRow = styled(FlexRowDiv) `
    flex: 1;
    min-width: 0;
    align-items: center;
    gap: 16px;
`;
export const ProfileHeroNameBlock = styled(FlexColumnDiv) `
    flex: 1;
    min-width: 0;
    gap: 0px;
`;
export const ProfileHeroFirstNameRow = styled(FlexRowDiv) `
    align-items: center;
    width: 100%;

    & > :first-child {
        flex: 1;
        min-width: 0;
    }
`;
export const ProfileAvatarWrapper = styled.div `
    position: relative;
    flex-shrink: 0;
`;
export const ProfileAvatarUploadOverlay = styled.div `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
`;
export const ProfileSheetBody = styled(FlexColumnDiv) `
    flex: 1 1 auto;
    align-self: stretch;
    min-height: 100%;
    background-color: ${profilePageBackground};
`;
export const Parent = styled(FlexColumnDiv) `
    gap: 0;
    position: relative;
    padding-bottom: 40px;
`;
export const ProfilePopoverContent = styled(FlexColumnDiv) `
    gap: 24px;
    padding: 24px;
    box-sizing: border-box;
    align-self: stretch;
`;
export const ProfileMenuContent = styled(FlexColumnDiv) `
    align-self: stretch;
`;
export const ContactPreferencePrompt = styled(FlexColumnDiv) `
    margin: 16px 24px 8px;
    padding: 16px;
    gap: 12px;
    border-radius: 12px;
    background: ${colors.navy_4};
    border: 1px solid ${colors.navy_light};
    box-sizing: border-box;
`;
export const ContactPreferencePromptHeader = styled(FlexRowDiv) `
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;
export const ContactPreferencePromptText = styled(FlexColumnDiv) `
    flex: 1;
    min-width: 0;
    gap: 4px;
`;
export const ContactPreferencePromptTitle = styled.span `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    line-height: 24px;
    letter-spacing: -0.31px;
    color: ${colors.black_main};
`;
export const ContactPreferencePromptBody = styled.span `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    line-height: 20px;
    color: ${colors.black_lighter};
`;
export const ContactPreferencePromptDismiss = styled.button `
    flex-shrink: 0;
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    color: ${colors.black_lighter};
    line-height: 0;
`;
export const ContactPreferencePromptActions = styled(FlexRowDiv) `
    justify-content: flex-end;
`;
export const ContactPreferencePromptCta = styled(HXMobileButton) `
    && {
        min-width: auto;
        height: 36px;
        padding: 0 16px;
        border-radius: 100px;
    }
`;
export const ProfileMenuItem = styled.button `
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 72px;
    padding: 16px 24px;
    border: 0;
    border-bottom: 1px solid ${colors.black_12};
    background: transparent;
    color: ${colors.black_main};
    cursor: pointer;
    text-align: left;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 24px;
    letter-spacing: -0.31px;

    & > :first-child {
        flex-shrink: 0;
    }
`;
export const ProfileMenuItemLabel = styled.span `
    flex: 1;
`;
export const ProfileMenuItemLabelDestructive = styled(ProfileMenuItemLabel) `
    color: ${colors.chips_scarlet};
`;
export const destructiveMenuIconSx = { width: 24, height: 24, color: colors.chips_scarlet };
export const ProfileMenuLanguage = styled.div `
    display: flex;
    justify-content: center;
    padding: 24px 24px 0;
`;
export const ContactPreferencesContent = styled(FlexColumnDiv) `
    align-self: stretch;
    padding: 24px;
    box-sizing: border-box;
`;
export const ProfileSubpageHeader = styled(FlexRowDiv) `
    position: relative;
    align-items: center;
    justify-content: center;
    min-height: 68px;
    padding: 24px 16px 12px;
    box-sizing: border-box;
`;
export const ProfileSubpageBackButton = styled.button `
    position: absolute;
    left: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid ${colors.black_lighter};
    border-radius: 50%;
    background: ${colors.white_main};
    color: ${colors.black_main};
    cursor: pointer;
`;
export const ProfileSubpageTitle = styled.h2 `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 21px;
    letter-spacing: -0.31px;
    color: ${colors.black_main};
`;
export const ContactSection = styled(FlexColumnDiv) `
    align-self: stretch;
`;
export const ContactSectionHeading = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 24px;
    color: ${colors.black_secondary_label};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    letter-spacing: 0.24px;

    &::after {
        content: "";
        height: 1px;
        flex: 1;
        background: ${colors.black_12};
    }
`;
export const ContactOption = styled.label `
    display: flex;
    align-items: stretch;
    flex: 1;
    min-width: 0;
    min-height: 70px;
    cursor: pointer;
`;
export const ContactOptionRow = styled(FlexRowDiv) `
    align-items: stretch;
    align-self: stretch;
    min-height: 70px;
`;
export const ContactOptionRadio = styled(Radio) `
    align-self: center;

    &.MuiRadio-root {
        color: ${colors.black_main};
    }

    &.Mui-checked {
        color: ${colors.black_main};
    }
`;
export const ContactOptionDetails = styled(FlexRowDiv) `
    flex: 1;
    min-width: 0;
    align-items: stretch;
    gap: 8px;
    border-bottom: 1px solid ${colors.separator_main};
`;
export const ContactOptionText = styled(FlexColumnDiv) `
    flex: 1;
    min-width: 0;
    justify-content: center;
`;
export const ContactOptionValue = styled.span `
    overflow-wrap: anywhere;
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 24px;
    letter-spacing: -0.31px;
`;
export const ContactOptionSource = styled.span `
    margin-top: 2px;
    color: ${colors.black_lighter};
    font-size: ${fontSizes.MICRO};
    font-weight: ${fontWeights.NORMAL};
    line-height: 14px;
    letter-spacing: 0.12px;
`;
export const RemoveContactButton = styled.button `
    align-self: center;
    flex-shrink: 0;
    margin: 0;
    padding: 8px 0;
    border: 0;
    background: transparent;
    color: ${(props) => (props.$muted ? colors.black_30 : colors.measurement_abnormal)};
    cursor: pointer;
    text-align: center;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    line-height: 18px;
`;
export const RemoveContactSheetBody = styled(FlexColumnDiv) `
    gap: 16px;
    width: 100%;
`;
export const RemoveContactSheetDescription = styled.p `
    margin: 0;
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 21px;
    letter-spacing: -0.31px;
`;
export const RemoveContactSheetActions = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    padding-top: 8px;
`;
export const AccessConsentSheetBody = styled(FlexColumnDiv) `
    gap: 16px;
    width: 100%;
`;
export const AccessConsentBadge = styled(ForestChip) `
    && {
        height: 24px;
        margin-top: -21px;
    }
    .MuiChip-label {
        padding: 0 8px;
    }
`;
export const AccessConsentDescription = styled.p `
    margin: 0;
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 21px;
    letter-spacing: -0.31px;
`;
export const AccessConsentLink = styled.a `
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
`;
export const AccessConsentActions = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    align-self: stretch;
    padding-top: 8px;
`;
export const AddContactMethodButton = styled.button `
    display: inline-flex;
    align-items: center;
    gap: 8px;
    align-self: flex-start;
    margin: 16px 0 8px 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.navy_main};
    cursor: pointer;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.BOLD};
    line-height: 21.5px;
    letter-spacing: -0.15px;
`;
export const AddContactOTPSubtitle = styled(LightText) `
    text-align: center;
    letter-spacing: -0.31px;
`;
export const AddContactMethodContent = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 12px;
    padding: 24px 24px 32px;
    box-sizing: border-box;
`;
export const ContactTypeToggle = styled(FlexRowDiv) `
    align-self: stretch;
    gap: 4px;
    padding: 4px;
    border-radius: 999px;
    background: ${colors.black_12_opaque};
    box-sizing: border-box;
`;
export const ContactTypeToggleOption = styled.button `
    flex: 1;
    min-height: 41.7px;
    padding: 8px 16px;
    border: 0;
    border-radius: 999px;
    font-size: ${fontSizes.SMALL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
    background: ${(props) => (props.$selected ? colors.white_main : "transparent")};
    color: ${(props) => (props.$selected ? colors.black_main : colors.black_lighter)};
    font-weight: ${(props) => (props.$selected ? fontWeights.BOLD : fontWeights.SEMI_BOLD)};
    box-shadow: ${(props) => (props.$selected ? "0 1px 4px rgba(7, 20, 32, 0.16)" : "none")};
    cursor: ${(props) => (props.$selected ? "default" : "pointer")};

    &:disabled {
        cursor: default;
    }
`;
export const ContactFieldGroup = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 4px;
`;
export const AddContactMethodTextField = styled(HXTextField) `
    && .MuiOutlinedInput-root {
        height: 48px;
        box-sizing: border-box;
        align-items: center;
        border-radius: 12px;

        fieldset {
            border-width: 2px;
            /*
             * Our border is always 2px (not MUI's default 1px -> 2px on focus), so 'top' must
             * stay identical across states too — otherwise the shared theme's focus-only
             * 'top: -4px' compensation (meant for a 1px shift) fights MUI's built-in unfocused
             * 'top: -5px' (baked into NotchedOutline) and the border box visibly jumps ~5px
             * between blurred and focused.
             */
            top: 0;

            legend {
                display: none;
            }
        }

        &:not(.Mui-error) fieldset {
            border-color: ${colors.navy_main};
        }

        &.Mui-focused fieldset {
            top: 0;
        }

        &.Mui-focused:not(.Mui-error) fieldset {
            border-color: ${colors.navy_main};
        }
    }

    && .MuiOutlinedInput-input {
        padding: 0 20px;
        font-size: ${fontSizes.LITTLE};
        height: auto;
        box-sizing: border-box;
        line-height: 18px;

        &::placeholder {
            line-height: inherit;
            opacity: 1;
        }

        /*
         * Chrome/Safari paint autofilled inputs with a lavender tint that ignores plain
         * background-color; the inset box-shadow trick is the reliable cross-browser override.
         */
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:autofill {
            -webkit-box-shadow: 0 0 0 1000px ${colors.white_main} inset;
            -webkit-text-fill-color: ${colors.black_main};
            caret-color: ${colors.black_main};
        }
    }
`;
export const ContactFieldLabel = styled.label `
    color: ${colors.black_main};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
`;
export const ContactFieldHelperText = styled.span `
    margin-left: 4px;
    color: ${colors.black_light};
    font-size: ${fontSizes.MICRO};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0;
`;
export const ContactFieldErrorText = styled.span `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.MICRO};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0;
`;
export const AddContactMethodActions = styled(FlexRowDiv) `
    align-self: flex-end;
    gap: 8px;
    padding-top: 24px;
`;
export const ContactPreferencesActionButton = styled(HXMobileButton) `
    && {
        min-width: 104px;
        border-radius: 28px;
        height: 52px;
        padding: 16px 24px;
    }

    &&.MuiButton-contained {
        background-color: ${colors.navy_light};

        &:hover,
        &:active,
        &:focus-visible {
            background-color: ${colors.navy_light};
        }
    }

    &&.MuiButton-outlined {
        border-color: ${colors.navy_light};
        color: ${colors.navy_light};

        &:hover {
            border-color: ${colors.navy_light};
        }
    }
`;
export const RemoveContactDestructiveButton = styled(ContactPreferencesActionButton) `
    &&.MuiButton-contained {
        background-color: ${colors.tulip_main};

        &:hover,
        &:active,
        &:focus-visible {
            background-color: ${colors.tulip_dark};
        }

        &.Mui-disabled {
            background-color: ${colors.tulip_main}33;
            color: ${colors.white_main};
        }
    }
`;
export const AddContactMethodPrimaryButton = styled(ContactPreferencesActionButton) `
    &&.MuiButton-contained {
        background-color: ${colors.navy_light};

        &:hover {
            background-color: ${colors.navy_light};
        }

        &:active,
        &:focus-visible {
            background-color: ${colors.navy_light};
        }

        &.Mui-disabled {
            background-color: ${colors.navy_light}33;
            color: ${colors.white_main};
        }
    }
`;
export const RadioIcon = styled(Radio) `
    width: ${radioIconSize}px;
    height: ${radioIconSize}px;
`;
export const InfoOutlinedIcon = styled(InfoOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
    display: block;
`;
export const Tooltip = styled(MUITooltip) ``;
export const TooltipContent = styled(FlexColumnDiv) `
    width: 200px;
`;
export const FormControlLabel = styled(MUIFormControlLabel) `
    align-self: stretch;
    .MuiSvgIcon-root {
        width: 24px;
        height: 24px;
    }

    &.MuiFormControlLabel-labelPlacementEnd {
        margin-left: 0; // There's a default -11 left-margin
    }
`;
export const TinyTextLighter = styled(DefaultTinyTextLighter) `
    margin-left: ${radioIconSize}px;
`;
export const TwilioFromPhoneNumber = styled.span `
    text-decoration-line: underline;
`;
const DialogText = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.4px;
`;
export const SpinnerText = styled(DialogText) `
    color: ${colors.black_lighter};
`;
export const DialogFooter = styled(DialogText) `
    color: ${colors.black_main};
`;
export const ConfirmDialogLink = styled.span `
    text-decoration-line: underline;
    cursor: pointer;
`;
